const diabetes_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   
   
   {
      "question":"Please indicate the treatment for ##name##?",
      "sub":"Check all that apply",
      "type":"radioModal",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2A"
      },
      "questions":[
         {
            "main":"None",
            "partialField": true,
            "dbqName":"F[0].Page_2[0].CB2_1a[0]",
            "answer":""
         }, 
         {
            "main":"Managed by restricted diet",
            "dbqName":"F[0].Page_2[0].CB2_1[0]",
            "answer":""
         },
         {
            "main":"Insulin required",
            "dbqName":"F[0].Page_2[0].CB2_3[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"1 Insulin injection per day",
                  "dbqName":"F[0].Page_2[0].CB2_4[1]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"More than 1 insulin injections per day",
                  "dbqName":"F[0].Page_2[0].CB2_4[0]",
                  "colWidth": 6,
                  "answer":""
               },           
            ],
            "subAnswer":"",
            "subItemsLabel" :"Number of Insulin injections"
         },
         {
            "main":"Prescribed oral hypoglycemic agent(s)",
            "dbqName":"F[0].Page_2[0].CB2_2[0]",
            "answer":""
         },
         {
            "main":"Other treatment",
            "dbqName":"F[0].Page_2[0].CB2_5[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "text1": "",
            "dbqName1": "F[0].Page_2[0].OtherDescribe[0]",
            "placeholder1":"Please describe about the treatment",
         },                      
      ],
      "answer":""
   },
   {
      "question":"Does ##name## is on any other treatment that is not listed on previous screen?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_2[0].CB2_5[0]",
      "dbqName_no":"pass_this_question",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe about the treatment",
      "textdbqName":"F[0].Page_2[0].OtherDescribe[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## require regulation of activities as part of medical management of Diabetes Mellitus? ",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "maxLength":175,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_2[0].Yes2[0]",
      "dbqName_no":"F[0].Page_2[0].No2[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please provide one or more examples",
      "textdbqName":"F[0].Page_2[0].Examples[0]",
      "textanswer":""
   },
   {
      "question":"How Frequently does ##name## visit his or her Diabetic care provider for episodes?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "questions":[
         {
            "label":"Visits for episodes of Ketoacidosis",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 2 times per month",
                  "dbqName":"F[0].Page_2[0].LessThan2[0]",
                  "sub":""
               },
               {
                  "main":"2 times per month",
                  "dbqName":"F[0].Page_2[0].TwoTimes[0]",
                  "sub":""
               },
               {
                  "main":"Weekly",
                  "dbqName":"F[0].Page_2[0].Weekly[0]",
                  "sub":""
               }
            ],
            "answer":"Weekly"
         },
         {
            "label":"Visits for episodes of Hypoglycemia",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 2 times per month",
                  "dbqName":"F[0].Page_2[0].LessThan2[1]",
                  "sub":""
               },
               {
                  "main":"2 times per month",
                  "dbqName":"F[0].Page_2[0].TwoTimes[1]",
                  "sub":""
               },
               {
                  "main":"Weekly",
                  "dbqName":"F[0].Page_2[0].Weekly[1]",
                  "sub":""
               }
            ],
            "answer":"Weekly"
         }
      ]
   },
   {
      "question":"How many episodes required hospitalization over the past 12 months?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2D"
      },
      "questions":[
         {
            "label":"Episodes of Ketoacidosis",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"No episode",
                  "dbqName":"F[0].Page_2[0].D_0[0]",
                  "sub":""
               },
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_2[0].D_1[0]",
                  "sub":""
               },
               {
                  "main":"2 episodes",
                  "dbqName":"F[0].Page_2[0].D_2[0]",
                  "sub":""
               },
               {
                  "main":"3 OR More",
                  "dbqName":"F[0].Page_2[0].D_3[0]",
                  "sub":""
               }
            ],
            "answer":"1 episode"
         },
         {
            "label":"Episodes of Hypoglycemia",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"No episode",
                  "dbqName":"F[0].Page_2[0].E_0[0]",
                  "sub":""
               },
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_2[0].E_1[0]",
                  "sub":""
               },
               {
                  "main":"2 episodes",
                  "dbqName":"F[0].Page_2[0].E_2[0]",
                  "sub":""
               },
               {
                  "main":"3 OR More",
                  "dbqName":"F[0].Page_2[0].E_3[0]",
                  "sub":""
               }
            ],
            "answer":"1 episode"
         }
      ]
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "section": {
         page: "4",
         title: "REMARKS",
         number: "7"
      },
      "options":[],
      "dbqName":"F[0].Page_4[0].Remarks[0]",
      "answer":""
   },
]
   
    export default diabetes_questions ;